export default __webpack_public_path__ + "static/image_about_s-4b624aea6b6855b2ef2a166394aaa540.jpg";